import { SxProps, Theme } from '@mui/material';

export enum TopRanking {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3
}

export interface HighlightCardProps {
  id: number | string;
  name: string;
  rank: number;
  points: number | string;
  point_type: string;
  metric_type: string;
  sx: SxProps<Theme>;
}
